import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import InviteFriendsCard from "./InviteFriendsCard";

type Props = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
};

export default function InviteFriendsDialog({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite friends to The Emerging Market</DialogTitle>
          <DialogDescription>
            Share your personal link with anyone who should be part of the shareholder network.
          </DialogDescription>
        </DialogHeader>
        <InviteFriendsCard variant="plain" />
      </DialogContent>
    </Dialog>
  );
}